import type { FaireThemeEntity } from "../../entity_types/theme";

export const faith_fun_and_mindful_play: FaireThemeEntity = {
  token: "faith-fun-and-mindful-play",
  type: "theme",
  name: "Faith, Fun & Mindful Play",
  description: "Encourage growth through educational activities and meaningful keepsakes. This collection blends faith-based inspiration with engaging tools for preschool-aged children.",
  teaser: "You frequently sell kids' clothing and have a history of ordering faith-based apparel like 'Jesus Loves You' sweatshirts. Your interest in coloring books and kids' gifts shows you cater to young families seeking wholesome, values-driven products.",
  detail: "Your current cart features a Preschool Activity Book, Calming Strategies cards, and a 'Rejoice in the Lord' charm necklace, perfectly bridging your kids' and faith-based categories.",
  bgColor: "#E8D5B7",
  tileBgColor: "#593c6b",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_fmk7bx2qkw",
    "p_8t2dmma33x",
    "p_vg7wjrh7pe",
    "p_p8y7wa4v34",
    "p_t7czy2wtup",
    "p_2rx453bcr6",
    "p_meqqa3wgx3",
    "p_eu3jdzfepf",
    "p_xustvkwdcc",
    "p_dvy3y88zdf",
    "p_s42n3838h7",
    "p_mf37ezvmfw",
    "p_tumgubh6yp",
    "p_jz35k3fsam",
    "p_p9hx4umsnb",
    "p_rq3tvqm7xt",
    "p_x2bnws2rzd",
    "p_g3qwvtgh46",
    "p_vud5xtehgy",
    "p_jsqxh3zbaa",
    "p_tphrz39n9k",
    "p_au7qjjvdvg",
    "p_t2vxwbjv63",
    "p_fm3wx9phj7",
    "p_6hsd69fav8",
    "p_zx2vcydjys",
    "p_32ux7j0t5z",
    "p_tb3exxtw3u",
    "p_azm4b8ydhd",
    "p_mxhmjyje4t",
    "p_r5wpwumgek",
    "p_9q595cvfmj",
    "p_tq3yf5ybzp",
    "p_f9haqs7tu2",
    "p_g57p4h5sw9",
    "p_whaznkuuf3",
    "p_eg4rqajj42",
    "p_fkep3mqh83",
    "p_9j5p73jqhn",
    "p_5nnpvjf32b",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
